import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EChartsOption } from 'echarts';
import { NumberSuffixPipe } from 'src/app/core/filters/numberSuffix-pipe';
import { PeriodicElement } from 'src/app/modules/shared/detailed-sr-view/detailed-sr-view.component';
import { MeritorService } from '../meritor.service';

@Component({
  selector: 'app-detailed-meritor-view',
  templateUrl: './detailed-meritor-view.component.html',
  styleUrls: ['./detailed-meritor-view.component.scss']
})
export class DetailedMeritorViewComponent implements OnInit {
  top: EChartsOption = {};
  bottom: EChartsOption = {};
  radio: string = 'ecc_major';
  qParam: any = {};
  property: any;
  title: any;
  part: any;
  flag: any;
  header: string = 'Engine Model';
  displayedColumns = ['name', 'price'];
  dataSource: any;

  topX: any[] = [];
  topY: any[] = [];
  bottomX: any[] = [];
  bottomY: any[] = [];
  total: any;
  response: any[] = [];
  filter: any;
  subModule: any;

  constructor(private route: ActivatedRoute, private service: MeritorService) { }

  ngOnInit(): void {
    this.title = this.route.snapshot.queryParamMap.get('title');
    this.property = this.route.snapshot.queryParamMap.get('property');
    this.part = this.route.snapshot.queryParamMap.get('part');
    this.flag = this.route.snapshot.queryParamMap.get('flag');
    this.subModule = this.route.snapshot.queryParamMap.get('subModule');

      this.qParam = {
        product_group: this.route.snapshot.queryParamMap.getAll('product_group'),
        channel: this.route.snapshot.queryParamMap.getAll('channel'),
        certification: this.route.snapshot.queryParamMap.getAll('certification'),
        bill_to_name: this.route.snapshot.queryParamMap.getAll('bill_to_name'),
        ecc: this.route.snapshot.queryParamMap.getAll('ecc'),
        main_region: this.route.snapshot.queryParamMap.getAll('main_region'),
        part_number: this.route.snapshot.queryParamMap.getAll('part_number'),
        ecc_major: this.route.snapshot.queryParamMap.getAll('ecc_major'),
        country: this.route.snapshot.queryParamMap.getAll('country'),
      };
      this.filter = '/' + this.route.snapshot.queryParamMap.getAll('filter');
    

    this.getTop();
    this.getBottom();
    this.getTable();
  }

  getTop() {
    this.topX = [];
    this.topY = [];
    this.service
      .getToporBottom(
        this.qParam,
        '/' +
        this.flag +
        '/' +
        this.part +
        '/' +
        this.property +
        '/top/10/' +
        this.radio +
        this.filter
      )
      .subscribe((results) => {
        results.map(
          (i: any) => (
            this.topX.push(i[this.radio]), this.topY.push(i[this.property])
          )
        );
        this.top = {
          tooltip: {
            trigger: 'item',

            axisPointer: {
              type: 'shadow',
            },
            formatter: function (params: any) {
              let tar;
              let value;
              tar = params;
              value = params.value.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              });
              return tar.name + '<br/>' + tar.seriesName + ' : ' + value;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              data: this.topX,
              axisLabel: {
                interval: 0,
                fontSize: 10,
                color: 'black',
                fontWeight: 500,
                // hideOverlap: true,
              },
              axisTick: {
                alignWithLabel: true,
              },
            },
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                formatter: function (xAxis) {
                  return NumberSuffixPipe.prototype.transform(xAxis, 0);
                },
              },
            },
          ],
          series: [
            {
              name: 'Value',
              type: 'bar',
              barWidth: 50,
              itemStyle: {
                color: function (d: any): any {
                  return d.value > 0 ? 'green' : 'red';
                },
                // borderRadius: [5, 5, 5, 5],
              },
              data: this.topY,
              label: {
                show: true,
                position: 'top',
                fontWeight: 700,
                color: 'black',
                formatter: function (d: any): any {
                  return NumberSuffixPipe.prototype.transform(d.data, 1);
                },
                fontSize: 12,
              },
            },
          ],
        };
      });
  }
  getBottom() {
    this.bottomX = [];
    this.bottomY = [];
    this.service
      .getToporBottom(
        this.qParam,
        '/' +
        this.flag +
        '/' +
        this.part +
        '/' +
        this.property +
        '/bottom/10/' +
        this.radio +
        this.filter
      )
      .subscribe((results) => {
        results.map(
          (i: any) => (
            this.bottomX.push(i[this.radio]),
            this.bottomY.push(i[this.property])
          )
        );
        this.bottom = {
          tooltip: {
            trigger: 'item',

            axisPointer: {
              type: 'shadow',
            },
            formatter: function (params: any) {
              let tar;
              let value;
              tar = params;
              value = params.value.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              });
              return tar.name + '<br/>' + tar.seriesName + ' : ' + value;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              data: this.bottomX,
              axisLabel: {
                interval: 0,
                fontSize: 10,
                color: 'black',
                fontWeight: 500,
                // hideOverlap: true,
              },
              axisTick: {
                alignWithLabel: true,
              },
            },
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                formatter: function (xAxis) {
                  return NumberSuffixPipe.prototype.transform(xAxis, 0);
                },
              },
            },
          ],
          series: [
            {
              name: 'value',
              type: 'bar',
              barWidth: 50,
              itemStyle: {
                color: function (d: any): any {
                  return d.value > 0 ? 'green' : 'red';
                },
                // borderRadius: [5, 5, 5, 5],
              },
              data: this.bottomY,
              label: {
                show: true,
                position: 'top',
                fontWeight: 700,
                color: 'black',
                formatter: function (d: any): any {
                  return NumberSuffixPipe.prototype.transform(d.data, 1);
                },
                fontSize: 12,
              },
            },
          ],
        };
      });
  }
  searchDimension(event) {
    switch (event) {
      case 'engine_model':
        this.header = 'Engine Model';
        break;
      case 'part_number':
        this.header = 'Parts';
        break;
      case 'certification':
        this.header = 'Channel Code';
        break;
      case 'country':
        this.header = 'Country';
        break;
      case 'ecc':
        this.header = 'DW-3-Digit Att';
        break;
      case 'manufacturer':
        this.header = 'Manufacturer';
        break;
      case 'lob_l2':
        this.header = 'LOB_L2';
        break;
      case 'ecc_major':
        this.header = 'DW-1-Digit Att';
        break;
    }
    this.radio = event;
    this.getTop();
    this.getBottom();
    this.getTable();
  }
  getTable() {
    this.service
      .getToporBottom(
        this.qParam,
        '/' +
        this.flag +
        '/' +
        this.part +
        '/' +
        this.property +
        '/' +
        this.radio +
        this.filter
      )
      .subscribe((res) => {
        const TABLE_DATA: PeriodicElement[] = [];
        this.response = res;
        res.map((data: any) => {
          this.total = data.total;
        });
        this.response.pop();
        this.response.map((data: any) => {
          TABLE_DATA.push({
            name: data[this.radio],
            price: data[this.property],
          });
        });

        this.dataSource = TABLE_DATA;
      });
  }
}
